export const getDisplayEvent = (state) => state.displayEvent;
export const getPresenceList = (state) => state.presenceList;
export const getTeamPresence = (state) => state.teamPresence;
export const getLivestream = (state) => state.livestream;
